import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from "./App";

import './assets/scss/styles.scss';
import { IntlProviderWrapper } from './util/IntlHelper';

// MSAL imports
import { EventType, EventMessage, AuthenticationResult, AuthError } from "@azure/msal-browser";
import { msalInstance } from "./util/authUtil";
import { ToastHandlerProvider } from './components/ToastHandler';

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
    console.log("accounts[0]", accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    document.documentElement.lang="fi";
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
        console.log("Login success: ", account);
    }
    else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      console.log("ACQUIRE_TOKEN_FAILURE:", event.error);
      if (event.error instanceof AuthError) {
        // If token acquire fails, at least logout for now...
        const account = msalInstance.getActiveAccount();
        const logoutRequest = {
          account
        }
        msalInstance.logoutRedirect(logoutRequest);
      }
    } else {
      //console.log("MSAL event", event.eventType);
    }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// To prevent login popup to render App
// (https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/5091#issuecomment-1342312690)
if (window.location.hash !== ''){
  console.log("hash found" + window.location.hash);
}
else {
  root.render(
    <IntlProviderWrapper>
      <ToastHandlerProvider>
        <BrowserRouter>
          {/* <React.StrictMode> */}
              <App />
          {/* </React.StrictMode> */}
        </BrowserRouter>
      </ToastHandlerProvider>
    </IntlProviderWrapper>
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
